module.exports = __webpack_public_path__ + "assets/fanwendengji.8f92e111.svg";